import { render, staticRenderFns } from "./v-dialog.vue?vue&type=template&id=09d1b6d4&scoped=true&"
import script from "./v-dialog.vue?vue&type=script&lang=js&"
export * from "./v-dialog.vue?vue&type=script&lang=js&"
import style0 from "./v-dialog.vue?vue&type=style&index=0&id=09d1b6d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d1b6d4",
  null
  
)

export default component.exports